var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "99006659-2FF3-42CA-A009-0C9B95BA8A64") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login-&-Signup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_Signup-w-Email",
    transform: "translate(-820.000000, -297.000000)",
    fill: "#C8CCD2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input",
    transform: "translate(589.000000, 278.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.756736,24.6931925 C240.594652,24.5340872 240.397968,24.4545943 240.16638,24.4545943 L239.88876,24.4545943 L239.88876,22.8181384 C239.88876,21.7727004 239.506915,20.8750541 238.742982,20.1250504 C237.979109,19.3750168 237.064919,19 235.999954,19 C234.93502,19 234.020647,19.3750168 233.256835,20.1250205 C232.492902,20.8750541 232.111057,21.7726705 232.111057,22.8181384 L232.111057,24.4545943 L231.833316,24.4545943 C231.60191,24.4545943 231.405104,24.5340872 231.24305,24.6931925 C231.080997,24.8521784 231,25.0454032 231,25.2728073 L231,30.1818467 C231,30.4090418 231.081027,30.6023264 231.24305,30.7614615 C231.405104,30.9204175 231.60191,31 231.833316,31 L240.166593,31 C240.398181,31 240.594834,30.9205071 240.756949,30.7614615 C240.918851,30.6023264 241,30.4090418 241,30.1818467 L241,25.2727178 C241.000121,25.0454928 240.918851,24.8522978 240.756736,24.6931925 Z M238.222159,24.4545943 L233.777749,24.4545943 L233.777749,22.8181384 C233.777749,22.2158966 233.994804,21.7016552 234.428822,21.2755934 C234.862902,20.8494719 235.386582,20.6364559 236.000045,20.6364559 C236.61357,20.6364559 237.137128,20.849442 237.571238,21.2755934 C238.005135,21.7016254 238.222159,22.2158966 238.222159,22.8181384 L238.222159,24.4545943 Z",
    id: "icon-lock"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.c0eb221afdb64920e74fe2e31c827549.svg";
export { ForwardRef as ReactComponent };